<template>
  <button class="btn-back" @click="handleBack">
    <img src="/icons/back.png" alt="Back" class="arrow-icon" />
    {{ text }}
  </button>
</template>

<script>
export default {
  name: 'BackButton',
  props: {
    text: {
      type: String,
      default: 'Back'
    },
    to: {
      type: Object,
      required: false
    }
  },
  emits: ['click'],
  methods: {
    handleBack() {
      if (this.to) {
        this.$router.push(this.to);
      } else {
        this.$emit('click');
      }
    }
  }
};
</script>

<style scoped>
.arrow-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-right: 8px;
}

.btn-back {
  background-color: #f99f44;
  color: rgb(0, 0, 0);
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-bottom: 20px;
}

.btn-back:hover {
  background-color: #f67d3c;
}
</style>
